import { TextareaAutosize } from "../../../common/MaterialComponent";
import { primaryBorder } from "../../../common/sharedStyle";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";
import "./MessageTitle.css";

export interface MessageTitleProps {
	messageTitleValue: string;
	onMessageContentChange: (content: string) => void;
	isReadOnly: boolean;
}

const MessageTitle = (props: MessageTitleProps) => {
	const strings = useGetComponentStringsContext().MessageTitle;
	return (
		<TextareaAutosize
			data-testid="messageTitle"
			rowsMin={4}
			value={props.messageTitleValue}
			onChange={(event: any) =>
				props.isReadOnly ? {} : props.onMessageContentChange(event.target.value)
			}
			className={
				"messageTitle " +
				(!props.isReadOnly
					? !props.messageTitleValue
						? " errorClass "
						: primaryBorder
					: null)
			}
			placeholder={strings.messageTitle}
			disabled={props.isReadOnly}
		/>
	);
};

export default MessageTitle;
